import React, {useRef} from "react";
import { useTranslation } from "react-i18next";
import { Link as LinkScroll, animateScroll as Scroll } from "react-scroll";
import { Link } from "react-router-dom";
import ToolbarLogo from '../assets/images/wd-logo-toolbar.jpg';
import BrFlag from '../assets/images/flags/flag-brazil.svg';
import UsFlag from '../assets/images/flags/flag-usa.svg';
import Footer from "../partials/Footer";
import Icon from "../components/Icon";

interface LandingProps {
	children: React.ReactNode;
}

const Landing = ({children}: LandingProps) => {

	const [NavOpen, setNavOpen] = React.useState(false);

	React.useEffect(() => {
		const appNav = document.getElementById('app-nav');
		console.log(NavOpen);

		if (NavOpen) {
			appNav?.classList.add('max-lg:flex');
			appNav?.classList.remove('max-lg:hidden');
		} else {
			appNav?.classList.add('max-lg:hidden');
			appNav?.classList.remove('max-lg:flex');
		}

	}, [NavOpen]);

	const { t, i18n } = useTranslation();

	const handleLanguageChange = (language: string) => {
		i18n.changeLanguage(language);
	};

	return (
		<>
			<nav className="fixed top-0 left-0 w-full flex items-center justify-center z-30">
				<div className="max-w-[96%] w-[1200px]">
					<div className="bg-white w-full p-4 rounded-b-md shadow-lg flex items-center justify-between flex-row">
						<Link to="/" className="logo flex items-center justify-center flex-row gap-2 text-gray-700 uppercase font-bold">
							<div className="h-12 rounded-md">
								<img src={ToolbarLogo} alt="WD Publicidade" className="w-full h-full object-contain" />
							</div>
							<h1 className="max-lg:hidden">{process.env.REACT_APP_NAME}</h1>
						</Link>

						<div
							className="lg:hidden text-slate-800 font-roboto font-bold flex items-center justify-center gap-2 flex-row hover:cursor-pointer"
							id="app-nav-open"
							onClick={() => setNavOpen(true)}
						>
							<span>MENU</span>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								className="w-8 h-8"
							>
								<line x1="3" y1="12" x2="21" y2="12" />
								<line x1="3" y1="6" x2="21" y2="6" />
								<line x1="3" y1="18" x2="21" y2="18" />
							</svg>
						</div>

						<div className="flex items-center gap-4 justify-center flex-row
										max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:w-full max-lg:h-full
										max-lg:bg-slate-900 max-lg:bg-opacity-90 max-lg:z-50
										max-lg:flex-col transition duration-500 max-lg:hidden
										max-lg:gap-16"
							id="app-nav"
						>
							<div
								className="py-1 px-2 rounded-md text-white font-bold font-roboto border-2 border-white lg:hidden hover:bg-white hover:text-slate-900 hover:cursor-pointer"
								id="app-nav-close"
								onClick={() => setNavOpen(false)}
							>
								FECHAR
							</div>
							
							<ul className="flex gap-2 items-center justify-center flex-row font-semibold
											font-roboto text-gray-800 max-lg:text-white max-lg:text-3xl
											max-lg:flex-col"
							>
								<li><Link to="/sobre-nos" className="z-10 relative max-lg:hover:underline hover:cursor-pointer">{t('menu.about')}</Link></li>
								<li><Link to="/servicos" className="z-10 relative max-lg:hover:underline hover:cursor-pointer">{t('menu.services')}</Link></li>
								<li><Link to="/clientes" className="z-10 relative max-lg:hover:underline hover:cursor-pointer">{t('menu.customers')}</Link></li>
								<li><Link to="/depoimentos" className="z-10 relative max-lg:hover:underline hover:cursor-pointer">{t('menu.testimonials')}</Link></li>
								<li><Link to="/contato" className="z-10 relative max-lg:hover:underline hover:cursor-pointer">{t('menu.contact')}</Link></li>
							</ul>
							
							<div className="flex flex-row gap-2 lg:gap-4 items-center justify-start">
								<img src={BrFlag} alt={ t('locales.ptBr') } className="w-12 hover:cursor-pointer" onClick={() => handleLanguageChange('pt')} />
								<img src={UsFlag} alt={ t('locales.us') } className="w-12 hover:cursor-pointer" onClick={() => handleLanguageChange('en')} />
							</div>
						</div>
					</div>
				</div>
			</nav>

			<main className="w-full">{children}</main>

			<a
				target="_blank"
				href="https://api.whatsapp.com/send?phone=12997301700&amp;text=Ol%C3%A1%2C+vim+do+site+e+gostaria+de+mais+informa%C3%A7%C3%B5es."
				id="whatsapp-button"
				style={{ position: 'fixed', bottom: '10px', right: '10px', width:'50px', height:'50px', zIndex: '999' }}
			>
				<img
					style={{ width: '100%' }}
					src="data:image/svg+xml;utf8;base64,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"
				/>
			</a>



			<Footer />
		</>
	);
}

export default Landing;
